import { useState, useEffect } from "react";
import { MessageCircle, X } from "lucide-react";
import { useBrandData } from "../hooks/useBrandData";

export default function WhatsAppButton() {
    const { brand } = useBrandData();
    const [visible, setVisible] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const t = setTimeout(() => setVisible(true), 2500);
        return () => clearTimeout(t);
    }, []);

    if (!visible) return null;

    const msg = encodeURIComponent(
        "Halo Sanggar Rias Adibah, saya tertarik untuk berkonsultasi mengenai layanan rias pengantin."
    );
    const wa = `https://wa.me/${brand.whatsapp}?text=${msg}`;

    return (
        <div
            data-testid="whatsapp-floating"
            className="fixed bottom-24 right-6 z-50 flex flex-col items-end gap-3"
        >
            {open && (
                <div className="bg-[#15120f] border border-[#d4af37]/30 p-5 max-w-[280px] shadow-[0_20px_60px_-10px_rgba(212,175,55,0.25)] animate-in fade-in slide-in-from-bottom-4 duration-500">
                    <button
                        onClick={() => setOpen(false)}
                        className="absolute top-2 right-2 text-[#a6a196] hover:text-[#d4af37]"
                        data-testid="whatsapp-card-close"
                    >
                        <X size={14} />
                    </button>
                    <p className="text-[9px] tracking-[0.4em] uppercase text-[#d4af37] mb-2">
                        Live Chat
                    </p>
                    <p className="font-serif text-[#fdfbf7] text-lg mb-3 leading-tight">
                        Sapa tim Adibah secara langsung
                    </p>
                    <p className="text-xs text-[#a6a196] leading-relaxed mb-4">
                        Konsultasi cepat, jawaban dari makeup artist
                        bersertifikat.
                    </p>
                    <a
                        href={wa}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="whatsapp-card-link"
                        className="block text-center bg-[#d4af37] text-[#0a0908] py-3 text-[10px] tracking-[0.3em] uppercase font-semibold hover:bg-[#f0c950] transition-all"
                    >
                        Mulai Chat
                    </a>
                </div>
            )}

            <button
                onClick={() => setOpen((o) => !o)}
                data-testid="whatsapp-button"
                className="group relative w-14 h-14 bg-gradient-to-br from-[#d4af37] to-[#a8862a] text-[#0a0908] flex items-center justify-center shadow-[0_10px_40px_-8px_rgba(212,175,55,0.5)] hover:scale-105 transition-transform"
                aria-label="Chat WhatsApp"
            >
                <span className="absolute inset-0 border border-[#d4af37] animate-ping opacity-40" />
                <MessageCircle size={22} strokeWidth={1.5} />
            </button>
        </div>
    );
}
